<template>
  <DublettenFilterPanel
    :optionsArray="kundenIdFilterOptions"
    :storeFunction="getKundenIdFilterFunction"
    :placeholder="$t('DUBLETTEN.FILTER.KUNDENNUMMER')"
    objectName="Kunde"
    :stateOptions="stateOptions"
    :appliedIds="appliedFilter.kundenIdFilter"
    :appliedState="appliedFilter.duplikatStateFilter"
    @apply="onApply"
  ></DublettenFilterPanel>
</template>

<script>
import { mapState } from 'vuex';

import {
  SET_KUNDEN_ID_FILTER,
  GET_KUNDEN_ID_FILTER_OPTIONS,
  SET_DUPLIKAT_STATE_FILTER,
  SET_APPLIED_FILTER,
} from '@/core/kunden/stores/kunden-dubletten-confirmation-filter.module';
import DublettenFilterPanel from '@/components/common/dubletten-filter-panel.vue';

export default {
  components: {
    DublettenFilterPanel,
  },
  computed: {
    stateOptions() {
      return [
        { text: 'Neu', value: 'New' },
        { text: 'Zusammengeführt', value: 'Merged' },
        { text: 'Abgelehnt', value: 'Declined' },
      ];
    },
    ...mapState({
      kundenIdFilterOptions: state => state.kundeDublettenConfirmationFilter.kundenIdFilterOptions,
      appliedFilter: state => state.kundeDublettenConfirmationFilter.appliedKundeDublettenConfirmationFilter,
    }),
  },
  methods: {
    getKundenIdFilterFunction(id) {
      return this.$store.dispatch(GET_KUNDEN_ID_FILTER_OPTIONS, { idFilter: id });
    },
    onApply({ ids, state }) {
      this.$store.commit(SET_KUNDEN_ID_FILTER, ids);
      this.$store.commit(SET_DUPLIKAT_STATE_FILTER, state);
      this.$store.commit(SET_APPLIED_FILTER, {
        kundenIdFilter: ids,
        duplikatStateFilter: state,
      });
      this.$emit('onClickSaveFilter');
    },
  },
};
</script>
